// extracted by mini-css-extract-plugin
export var contrastLow = "_2m-1";
export var externalLink = "_2m-2";
export var externalLinkIcon = "_2m-3";
export var link = "_2m-0";
export var linkLabel = "_2m-4";